import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function TrophyIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M11 19v-3.1a5.4 5.4 0 0 1-2.187-1.037A4.5 4.5 0 0 1 7.4 12.95a4.85 4.85 0 0 1-3.137-1.637A4.8 4.8 0 0 1 3 8V7q0-.824.587-1.412A1.93 1.93 0 0 1 5 5h2q0-.824.588-1.412A1.93 1.93 0 0 1 9 3h6q.824 0 1.413.587Q17 4.176 17 5h2q.824 0 1.413.588Q21 6.175 21 7v1q0 1.9-1.262 3.313A4.85 4.85 0 0 1 16.6 12.95q-.45 1.15-1.413 1.913A5.4 5.4 0 0 1 13 15.9V19h3q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 16 21H8a.97.97 0 0 1-.713-.288A.97.97 0 0 1 7 20q0-.424.287-.712A.97.97 0 0 1 8 19zm-4-8.2V7H5v1q0 .95.55 1.713.55.762 1.45 1.087m5 3.2q1.25 0 2.125-.875A2.9 2.9 0 0 0 15 11V5H9v6q0 1.25.875 2.125A2.9 2.9 0 0 0 12 14m5-3.2q.9-.326 1.45-1.088T19 8V7h-2z" />
    </Icon>
  );
}

TrophyIcon.displayName = 'TrophyIcon';
